import '../../css/base.css';

const Miscellaneous = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Other</h2>
      <p className="your-stay-text">Travel cot and high chair located in under-stairs cupboard.
                                    Ironing board, Iron and hoover located in under stairs cupboard. 
      </p>                                            
      <p className="your-stay-text">Bin and recycling day is Wednesday. Blue bin is recycling.  Green bin is general rubbish.  Glass is not collected so 
                                    please recycled your glass at the bottle bank in Glenelg (main road on the right when leaving the village).
      </p>                                            
      <p className="your-stay-text">We have a septic tank so please do not put any tampons, towels or
                                    anything other than toilet paper down the toilet. Thank you for your cooperation.
      </p>                                            
      <p className="your-stay-text">In the summer midges can be a occasionaly be a nuisance outside.  This is normally only if it is very still as 
                                    a slight breeze keeps them away.  You can use your favourite repellant but I find just keeping moving outdoors helps.
                                    Lastly there is a tick removal tool in the kitchen draw.  Just grasp them as close to the skin as possible 
                                    and pull.  Very simple.
      </p>                                            
    </div>
  );
}

export default Miscellaneous;